import { render, staticRenderFns } from "./SignUpQrView.vue?vue&type=template&id=72d57a7d&scoped=true&"
import script from "./SignUpQrView.vue?vue&type=script&lang=js&"
export * from "./SignUpQrView.vue?vue&type=script&lang=js&"
import style0 from "./SignUpQrView.vue?vue&type=style&index=0&id=72d57a7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d57a7d",
  null
  
)

export default component.exports